import { useEffect, useState } from 'react';
import {
  consumeGitHubRedirect,
  getGitHubRedirectFromState,
  handleGitHubCallback,
  setGitHubToken,
} from '../auth/github';
import { githubOAuthExchange } from '../api/github/oauthExchange';
import { toAppError } from '../api/errors';
import { useToast } from '../components/shared/Toast';
import { vscodeTheme } from '../styles/theme';

export function GitHubCallback() {
  const [message, setMessage] = useState('認証処理中です…');
  const { showToast } = useToast();

  useEffect(() => {
    let timeoutId: number | undefined;

    const handleCallback = async () => {
      const { token, code, error } = handleGitHubCallback();

      if (error) {
        setMessage(`GitHub認証に失敗しました: ${error}`);
        showToast(`GitHub認証に失敗しました: ${error}`, 'error');
        timeoutId = window.setTimeout(() => window.history.back(), 3000);
        return;
      }

      if (token) {
        const redirect = getGitHubRedirectFromState() ?? consumeGitHubRedirect();
        setMessage('認証が完了しました。元の画面へ戻ります…');
        window.location.replace(redirect ?? '/');
        return;
      }

      if (code) {
        setMessage('認証コードを受信しました。トークン交換中です…');
        try {
          const response = await githubOAuthExchange({ code });
          setGitHubToken(response.access_token);
          const redirect = getGitHubRedirectFromState() ?? consumeGitHubRedirect();
          setMessage('認証が完了しました。元の画面へ戻ります…');
          window.location.replace(redirect ?? '/');
          return;
        } catch (err) {
          const appError = toAppError(err);
          setMessage(`トークン交換に失敗しました: ${appError.message}`);
          showToast(`トークン交換に失敗しました: ${appError.message}`, 'error');
          timeoutId = window.setTimeout(() => window.history.back(), 3000);
          return;
        }
      }

      setMessage('認証情報が見つかりませんでした。再ログインしてください。');
    };

    void handleCallback();

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [showToast]);

  return (
    <div
      style={{
        backgroundColor: vscodeTheme.colors.editorBackground,
        color: vscodeTheme.colors.textPrimary,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: vscodeTheme.typography.fontFamily,
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '520px' }}>
        <h1 style={{ fontSize: '20px', marginBottom: '12px' }}>GitHub認証</h1>
        <p style={{ color: vscodeTheme.colors.textSecondary }}>{message}</p>
      </div>
    </div>
  );
}
